import React from 'react';

import {useSelector} from "react-redux";
import {Col, Row} from "reactstrap";
import BBIconCompanyVerifiedCheck from "../../../assets/bbCustomIcons/BBIconCompanyVerifiedCheck";
import {
    bbDangerousStringToDate,
    bbFindEntityWithinPortfolioOrSelf,
    bbNumDaysBetweenDates,
    filterObject
} from "../../../util/bbHelpers";
import {Tooltip} from "@mui/material";
import BBIconProgressDonut30 from "../../../assets/bbCustomIcons/BBIconProgressDonut30";
import BBIconProgressDonut90 from "../../../assets/bbCustomIcons/BBIconProgressDonut90";
import BBIconProgressDonut60 from "../../../assets/bbCustomIcons/BBIconProgressDonut60";
import BBIconProgressDonut70 from "../../../assets/bbCustomIcons/BBIconProgressDonut70";
import BBIconProgressDonut40 from "../../../assets/bbCustomIcons/BBIconProgressDonut40";
import BBIconProgressDonut50 from "../../../assets/bbCustomIcons/BBIconProgressDonut50";
import BBIconProgressDonut80 from "../../../assets/bbCustomIcons/BBIconProgressDonut80";

const BRCompanyScopeProgressBadge = ({
    entityId = null,
    hideDescription = false,
    fontSizeOverride = false,
    inline = false
                         }) => {


    const {customers, customerInView, loadingCustomers} = useSelector(({customer}) => customer);
    const { portfolios, entityInView, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
    const entityIdToUse = entityId ? entityId : entityInView;
    //
    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    //
    const entity = bbFindEntityWithinPortfolioOrSelf(entityIdToUse, portfolios, customerIdToUse);

    console.log("BRCompanyScopeProgressBadge", "entityId", entityId, "entityIdToUse", entityIdToUse, "customerIdToUse", customerIdToUse, "entity", entity);

    const loading = !portfolios || (customerIdToUse && loadingPortfolios && loadingPortfolios[customerIdToUse]);

    /*  jfd**********22.Dec.06.14:27*****
     *   Dec 2022 Scope badge
     *   A circle donut that shows different stages of how much scope they've added.
     *
     * hacker's view would be if they dont have any verifications, but don't have access to that yes so can take a guess
     * settings.active_testing_authorized = doing pen testing
     * validations  is object that holds the last attestations. if with last 90 days its good
     *
     * it should really be about what's in scope. unhelped -> pen testing -> verifications -> current attestations
     * but will do v1 with just nothing -> pen testing -> current attestations
     *
     *   If attestation is true, blue donut 90% full
     *   If all true except recent attestation, blue donut 60% full
     *   Otherwise, (no pen testing, and no current attestation), 30% full of "hackers POV"
         ********************** `--===<>==<>==C>-< */

    const onboardingProgress = entity && entity.onboarding_progress

    const isPenTestingAuthorized = entity && entity.settings && entity.settings.active_testing_authorized;
    const isCloudIntegrationsAdded = onboardingProgress && (onboardingProgress.added_cloud_integrations);
    const isVerificationAdded = onboardingProgress && ((onboardingProgress.added_additional_domains || onboardingProgress.added_additional_identities || onboardingProgress.added_additional_ips) || onboardingProgress.added_additional_cyberspace);

    const attestations = entity && entity.validation;
    const attestationsMarkedTrue = attestations ? filterObject(attestations, (_, validation) => validation.validated) : null;
    //get all dates from validation objects
    const attestationDates = []
    for (const attestationId in attestationsMarkedTrue) {
        attestationDates.push(bbDangerousStringToDate(attestationsMarkedTrue[attestationId].created_datetime));
    }

    //sort
    // validationDates.sort((a, b) => a - b);
    const sortedAttestationDates = attestationDates && Array.isArray(attestationDates) && attestationDates
        .sort((a,b) => (bbDangerousStringToDate(a) < bbDangerousStringToDate(b) ? 1 : -1));
    // console.log("sortedValidationDates", sortedValidationDates);

    const lastTrueAttestationDate = sortedAttestationDates.length ? sortedAttestationDates[0] : "--";

    const isAttestationPresentFromWithinPast90Days = bbNumDaysBetweenDates(lastTrueAttestationDate) <= 90;

    let badgeDisplayText = ""
    let badgeDisplayColor = "text-light-gray"
    let badgeTooltipText = ""
    let badgeIcon = <BBIconProgressDonut30
        style={{fontSize: "2.5em"}}
        className={`mb-0 pb-0 text-gray`}
    />
    const badgeFontSize = fontSizeOverride ? fontSizeOverride : "2.5em"

    //determine the values
    if(isAttestationPresentFromWithinPast90Days && isVerificationAdded && isPenTestingAuthorized){
        //this is the best case
        badgeDisplayText = "Full Active"
        badgeDisplayColor = "text-electric-blue"
        badgeTooltipText = "Full Point of View | The most expansive perspective possible. This BreachRisk™ Score has been certified within the past 90 days by this company to include the full scope of this company's cyberspace. They are also conducting BreachRisk™ penetration testing."
        badgeIcon =  <BBIconProgressDonut90
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    }   else if(isAttestationPresentFromWithinPast90Days && isPenTestingAuthorized){
        //this is the best case but is just here as a fallback until we get the boolean for verifications added
        badgeDisplayText = "Active*"
        badgeDisplayColor = "text-electric-blue-light"
        badgeTooltipText = "Active Point of View (*Pending Expansion Confirmation) | This company has current attestations but expanded scope is pending. They are conducting BreachRisk™ penetration testing. There may be elements of cyberspace that they control that are not being surveyed."
        badgeIcon =  <BBIconProgressDonut70
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    } else if(!isAttestationPresentFromWithinPast90Days && isVerificationAdded && isPenTestingAuthorized){
        //no attestation, but verifications and pen testing
        badgeDisplayText = "Active"
        badgeDisplayColor = "text-light-gray"
        badgeTooltipText = "Expanded Active Point of View | This company has expanded scope and is conducting BreachRisk™ penetration testing, but they do not have a current attestation. There may be elements of cyberspace that they control that are not being surveyed."
        badgeIcon =  <BBIconProgressDonut70
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    } else if(isAttestationPresentFromWithinPast90Days && isVerificationAdded && !isPenTestingAuthorized){
        //attestation but verifications but no pen testing
        badgeDisplayText = "Expanded"
        badgeDisplayColor = "text-light-gray"
        badgeTooltipText = "Expanded Passive Point of View | This company has certified that the full scope of this company's cyberspace is being surveyed. But they are not conducting BreachRisk™ penetration testing."

        badgeIcon =  <BBIconProgressDonut60
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    }  else if(isAttestationPresentFromWithinPast90Days && !isVerificationAdded && !isPenTestingAuthorized){
        //attestation and no verifications but no pen testing
        badgeDisplayText = "Limited"
        badgeDisplayColor = "text-bb-risk-high"
        badgeTooltipText = "Limited Passive Point of View | This company has certified that the full scope of this company's cyberspace is being surveyed. But they are not conducting BreachRisk™ penetration testing and they have not expanded scope beyond the hacker's view, which is possible but unusual."
        badgeIcon =  <BBIconProgressDonut50
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    }  else if (!isAttestationPresentFromWithinPast90Days && !isVerificationAdded && isPenTestingAuthorized) {
        //they are pen testing, so its better than nothing
        badgeDisplayText = "Attacker"
        badgeDisplayColor = "text-bb-risk-high"
        badgeTooltipText = "Attacker's Active Point of View | This BreachRisk™ Score is only based off of a hacker's planning and attack attempts - without knowing the full scope of this company's cyberspace. This company is engaged in active BreachRisk™ penetration testing, but results may not include all of this company's cyberspace."
        badgeIcon =  <BBIconProgressDonut40
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    } else {
        //no stages of verification
        badgeDisplayText = "Attacker"
        badgeDisplayColor = "text-bb-risk-highest"
        badgeTooltipText = "Attacker's Planning Point of View | This BreachRisk™ Score is only based off of a hacker's targeted attack planning - before the attack starts. This company has not added any further scope and they are not conducting BreachRisk™ pentration testing. Results may not include all of this company's cyberspace."
        badgeIcon =  <BBIconProgressDonut30
            style={{fontSize: badgeFontSize}}
            className={`mb-0 pb-0 ${badgeDisplayColor}`}
        />
    }

    const badge = <>
                <Tooltip title={badgeTooltipText}>
                    <span className={"text-center animated fadeIn animation-duration-7"}>
                        <Row>
                            <Col>
                                {badgeIcon}
                            </Col>
                        </Row>
                        {!hideDescription &&
                            <>
                                <Row>
                                    <Col style={{fontSize: "x-small"}}>
                                        {badgeDisplayText}
                                    </Col>
                                </Row>
                            </>
                        }
                        </span>
                     </Tooltip>
                    </>

    const badgeInline = <span className={"mx-1 animated fadeIn animation-duration-7"}>
        <Tooltip title={badgeTooltipText}>
                    <span>
                                {badgeIcon}
                        {!hideDescription &&
                                    <span style={{fontSize: "x-small"}}>
                                        {badgeDisplayText}
                                    </span>

                        }
                        </span>
        </Tooltip>
    </span>

    //TODO: Uncomment this out to enable the badge. Removed for the 7Dec2022 push to prod
    // if(loading){
    //     return null
    // }else {
    //     return hideBadge ? null : inline ? badgeInline : badge;
    // }

    //for now, return nothing which is easier than finding the 10 spots to uncomment
    return null;


}

export default BRCompanyScopeProgressBadge;